import { ResponsiveContainer } from '@/components/layout/responsive-container';
import { Button } from '@/components/ui/button';
import { useConvexMutation } from '@convex-dev/react-query';
import { useMutation } from '@tanstack/react-query';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '~/convex/_generated/api';
import { TemplateForm, type TemplateFormValues } from './form';

export const TemplateCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutate: createTemplate, isPending: isCreating } = useMutation({
    mutationFn: useConvexMutation(api.templates.create),
  });

  const handleSubmit = async (values: TemplateFormValues) => {
    createTemplate(
      {
        name: values.name.trim(),
        sections: values.sections,
        language: values.language,
      },
      {
        onSuccess: () => {
          toast.success(t('templates:templateCreated'));
          navigate('/templates');
        },
        onError: (error) => {
          toast.error(t('errors:errorCreatingTemplate'));
          console.error('Error creating template:', error);
        },
      },
    );
  };

  return (
    <div className="flex min-h-full w-full flex-col bg-white">
      <ResponsiveContainer
        scrollAwareBorder
        className="flex w-full flex-row items-center gap-3 bg-white py-4 md:pt-6">
        <Button
          className="cursor-pointer md:hidden"
          variant="ghost"
          size="icon"
          onClick={() => navigate(-1)}>
          <ChevronLeft className="size-5" />
        </Button>
        <h1 className="text-2xl font-bold">{t('templates:create')}</h1>
      </ResponsiveContainer>
      <TemplateForm
        onSubmit={handleSubmit}
        onCancel={() => navigate('/templates')}
        isSubmitting={isCreating}
      />
    </div>
  );
};
